import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: var(--gray-50);
`;

const Content = styled(motion.div)`
  text-align: center;
  max-width: 500px;
`;

const ErrorCode = styled.h1`
  font-size: 6rem;
  font-weight: 700;
  color: var(--primary-color);
  margin: 0;
  line-height: 1;
`;

const Title = styled.h2`
  font-size: 2rem;
  color: var(--gray-800);
  margin: 1rem 0;
`;

const Description = styled.p`
  color: var(--gray-600);
  font-size: 1.125rem;
  margin-bottom: 2rem;
`;

const Button = styled.button`
  background: var(--primary-color);
  color: white;
  padding: 1rem 2rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  font-size: 1rem;
  transition: var(--transition);
  
  &:hover {
    background: var(--primary-dark);
    transform: translateY(-2px);
  }
`;

const NotFound = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem('fdv_token');

  return (
    <Container>
      <Content
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <ErrorCode>404</ErrorCode>
        <Title>Página não encontrada</Title>
        <Description>
          A página que você está procurando não existe ou foi movida.
        </Description>
        <Button onClick={() => navigate(token ? '/dashboard' : '/entrar')}>
          <i className="fas fa-home" style={{ marginRight: '0.5rem' }} />
          {token ? 'Voltar ao dashboard' : 'Ir para o login'}
        </Button>
      </Content>
    </Container>
  );
};

export default NotFound; 